var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-radio-group tw-flex-grow tw-grid tw-grid-flow-row tw-gap-3"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }